import ProgramLine from './components/program_line'
import PromoLine from './components/promo_line'
import Footer from './components/footer'
import Header from './components/header'
import SearchField from './components/search_field'
import Pagination from './components/pagination'
import ProjectDetailTabs from './components/project_detail'
import Schedule from './components/schedule'
// import videoPlayer from './player/videoPlayer'
import CookieWidget from './components/cookie-widget';

import $ from 'jquery'

import './css/app.scss'

document.addEventListener('DOMContentLoaded', () => {
	;[Footer, Header, ProgramLine, PromoLine, SearchField, Pagination, ProjectDetailTabs, Schedule].forEach(
		(element) => {
			element.init()
		}
	)
	//	videoPlayer()
	document.querySelector('.js-popup-link')
		? $(document).on('click', '.js-popup-link', function (e) {
			e.preventDefault()

			var data = $(this).data('link')
			$('.js-popup').removeClass('active')

			$('html').addClass('locked')
			$('.js-popup-bg').addClass('active')
			$('.js-popup-' + data).addClass('active')
		})
		: null
	document.querySelector('.js-popup-close')
		? $(document).on('click', '.js-popup-close', function (e) {
			e.preventDefault()

			closePopup()
		})
		: null

	contentHeight()
	$(window).resize(function () {
		console.log('REsize')
		contentHeight()
	})

	function closePopup() {
		$('html').removeClass('locked')
		$('.js-popup').removeClass('active')
		$('.js-popup-bg').removeClass('active')
	}

	function contentHeight() {
		var windowHeight, headerHeight, footerHeight, promoHeight, programHeight, advertHeight, containerHeight
		windowHeight = $(window).outerHeight()

		headerHeight = $('.header').outerHeight()
		footerHeight = $('.footer').outerHeight()

		promoHeight = 0
		programHeight = 0

		if ($('.promo-line').length > 0) {
			promoHeight = $('.promo-line').outerHeight()
		}

		if ($('.program-line').length > 0) {
			programHeight = $('.program-line').outerHeight()
		}

		if ($('.advert').length > 0) {
			advertHeight = $('.advert').outerHeight()
		}

		containerHeight = windowHeight - headerHeight - promoHeight - programHeight - advertHeight - footerHeight

		$('.container .content').css('min-height', containerHeight)
	}
	document.querySelector('.chat') ? chat() : null
	document.querySelector('.office') ? chat_office() : null
	document.querySelector('.train') ? chat_train() : null
	const CWidget = new CookieWidget({
		cookieName: 'HorrorCookie',
		cookieExpiryHrs: 48, // Cookie на 48 часов
		cookieTheme: 'is-dark', //  3 темы: дефолтная, тёмная, is-mzk
		cookieHtml: null, // если надо заменить html виджета
		cookieScroll: 100 // если задан, то виджет инициализируется по скроллу, типа 100px
	});
})
window.addEventListener('load', () => {
	document.querySelector('.load') && document.querySelector('.load').classList.remove('load')
})
